import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-191081c7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-table" }
const _hoisted_2 = {
  key: 1,
  style: {"margin-left":"120px","width":"540px"}
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  style: {"width":"58px","height":"30px"}
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode("提 交")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("确定")

import { ElMessage } from "element-plus";
import { addQuestions, getQuestionInfo } from "@/api/backstage";
import { useRouter, useRoute } from "vue-router";
import type { ElForm } from "element-plus";
import { reactive, ref, onMounted } from "vue";
import TEditor from "@/components/editor/TEditor.vue";

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  __name: 'examQuestionDetails',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const title = ref("");
const ruleFormRef = ref<FormInstance>();
const dialogVisible = ref(false);
const datas: any = reactive({
  options: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K"],
  subject: [],
  content: "",
  isValidationExecuted: false,
  index: [], //选项
  type: {
    QUESTION_ONE: {
      enumName: "单选",
      enumKey: "QUESTION_ONE",
    },
    QUESTION_MORE: {
      enumName: "多选",
      enumKey: "QUESTION_MORE",
    },
    QUESTION_SHORT: {
      enumName: "简答",
      enumKey: "QUESTION_SHORT",
    },
    QUESTION_NUM: {
      enumName: "打分",
      enumKey: "QUESTION_NUM",
    },
  },
  konwles: "",
  ruleForm: {
    title: "",
    type: "",
    options: [
      { title: "A", description: "", questionId: "0" },
      { title: "B", description: "", questionId: "1" },
      { title: "C", description: "", questionId: "2" },
      { title: "D", description: "", questionId: "3" },
    ],
  },
});
const rule = {
  title: [{ required: true, message: "请输入题干", trigger: "blur" }],
  type: [{ required: true, message: "请选择类型", trigger: "blur" }],
};
const getInfo = async () => {
  const res = await getQuestionInfo({ id: route.query.id });
  datas.ruleForm.title = res.data.title;
  datas.ruleForm.type = res.data.type;
  datas.content = res.data.title;
  datas.ruleForm.options = res.data.options;
};
const putDatas = () => {
  if (route.query.id) {
    datas.ruleForm.id = route.query.id;
  }
  addQuestions(datas.ruleForm).then((res: any) => {
    if (res.code === 200) {
      ElMessage({
        message: "操作成功",
        type: "success",
      });
      router.go(-1);
    } else {
      ElMessage({
        message: res.msg,
        type: "error",
      });
    }
  });
};

const submitForm = (formEl: FormInstance | undefined) => {
  console.log(datas.ruleForm);
  //   if (datas.ruleForm.type === "QUESTION_SHORT"||datas.ruleForm.type === "QUESTION_NUM") datas.ruleForm.title = datas.content;
  // console.log(title.value);
  // if (datas.ruleForm.type === "QUESTION_ONE"||datas.ruleForm.type === "QUESTION_MORE")
  //   datas.ruleForm.options[datas.index].description = datas.content;
  for (const item of datas.ruleForm.options) {
    if (item.description.length === 0) {
      ElMessage({
        message: "选项不能为空",
        type: "error",
      });
      return;
    }
  }

  if (!formEl) return;
  formEl.validate((valid) => {
    console.log(valid);
    if (valid) {
      putDatas();
    } else {
      console.log("error submit!");
      return false;
    }
  });
};
const open = (t: any, key: any) => {
  dialogVisible.value = true;
  if (t === "选项") {
    datas.content = datas.ruleForm.options[key].description;
    datas.index = key;
    title.value = `选项 ${datas.ruleForm.options[key].title}`;
  } else {
    title.value = t;
    datas.content = datas.ruleForm.title;
  }
};
const filsh = () => {
  dialogVisible.value = false;
  if (title.value === "题干") datas.ruleForm.title = datas.content;
  console.log(title.value);
  if (title.value.slice(0, 2) === "选项")
    datas.ruleForm.options[datas.index].description = datas.content;
};

const add = () => {
  datas.ruleForm.options.push({
    title: datas.options[datas.ruleForm.options.length],
    description: "",
    questionId: String(datas.ruleForm.options.length),
  });
    if (datas.ruleForm.options.length == 2) {
    datas.ruleForm.options[0].title = "A";
    datas.ruleForm.options[1].title = "B";
  }
    if (datas.ruleForm.options.length == 3) {
    datas.ruleForm.options[0].title = "A";
    datas.ruleForm.options[1].title = "B";
    datas.ruleForm.options[2].title = "C";
  }
  if (datas.ruleForm.options.length == 4) {
    datas.ruleForm.options[0].title = "A";
    datas.ruleForm.options[1].title = "B";
    datas.ruleForm.options[2].title = "C";
    datas.ruleForm.options[3].title = "D";
  }
    if (datas.ruleForm.options.length == 5) {
    datas.ruleForm.options[0].title = "A";
    datas.ruleForm.options[1].title = "B";
    datas.ruleForm.options[2].title = "C";
    datas.ruleForm.options[3].title = "D";
    datas.ruleForm.options[4].title = "E";

  }
    if (datas.ruleForm.options.length == 6) {
    datas.ruleForm.options[0].title = "A";
    datas.ruleForm.options[1].title = "B";
    datas.ruleForm.options[2].title = "C";
    datas.ruleForm.options[3].title = "D";
    datas.ruleForm.options[4].title = "E";
    datas.ruleForm.options[5].title = "F";

  }
};
const reduce = (index: any) => {
  datas.ruleForm.options.splice(index, 1);
};

const selectChange = (v: any) => {
  if (v === "QUESTION_SHORT" || v === "QUESTION_NUM") {
    // 如果是简单 计算空数
    datas.ruleForm.options = [];
  } else if (v === "QUESTION_ONE" || v === "QUESTION_MORE") {
    datas.ruleForm.options = [
      { title: "A", description: "", questionId: "0" },
      { title: "B", description: "", questionId: "1" },
      { title: "C", description: "", questionId: "2" },
      { title: "D", description: "", questionId: "3" },
    ];
  }
};
const scoreChange = (v: any) => {
  for (const item of datas.ruleForm.options) {
    datas.ruleForm.score = datas.ruleForm.score + item.score;
  }
};
onMounted(() => {
  if (route.query.id) getInfo();
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_scrollbar, { ref: "scrollbarRef" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_el_form, {
            ref_key: "ruleFormRef",
            ref: ruleFormRef,
            model: datas.ruleForm,
            rules: rule,
            "label-width": "120px"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: "类型",
                prop: "type"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: datas.ruleForm.type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((datas.ruleForm.type) = $event)),
                    placeholder: "请选择",
                    onChange: selectChange,
                    style: {"width":"520px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.type, (v, k) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          label: v.enumName,
                          value: k,
                          key: k
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "题干",
                prop: "title"
              }, {
                default: _withCtx(() => [
                  _createVNode(TEditor, {
                    modelValue: datas.ruleForm.title,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((datas.ruleForm.title) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              (
              datas.ruleForm.type == 'QUESTION_ONE' ||
              datas.ruleForm.type == 'QUESTION_MORE'
            )
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: "选项",
                    prop: "options"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_tooltip, {
                        content: "添加选项",
                        placement: "top"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("i", {
                            class: "iconfont icon-zengjia",
                            onClick: add
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (
              datas.ruleForm.type == 'QUESTION_ONE' ||
              datas.ruleForm.type == 'QUESTION_MORE'
            )
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(datas.ruleForm.options, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "options"
                      }, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_el_input, {
                            modelValue: item.title,
                            "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                            style: {"width":"50px","margin-right":"20px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_input, {
                            type: "textarea",
                            modelValue: item.description,
                            "onUpdate:modelValue": ($event: any) => ((item.description) = $event),
                            style: {"width":"450px","margin-right":"20px"}
                          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                          _createVNode(_component_el_tooltip, {
                            content: "删除选项",
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              (index != 0)
                                ? (_openBlock(), _createElementBlock("i", {
                                    key: 0,
                                    class: "iconfont icon-jianshao",
                                    onClick: ($event: any) => (reduce(index))
                                  }, null, 8, _hoisted_4))
                                : _createCommentVNode("", true),
                              (index == 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1024)
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value))),
                style: {"margin":"40px 10px","padding":"0 20px"}
              }, {
                default: _withCtx(() => [
                  _hoisted_6
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(router).go(-1)))
              }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((dialogVisible).value = $event)),
      title: title.value,
      width: "50%",
      style: {"z-index":"4"}
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: filsh
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(TEditor, {
          modelValue: datas.content,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((datas.content) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})